import { gql } from '@apollo/client';

export const getWebCalculationsSupplementary = gql`
  query getCalculations($input: CalculationRequestInput!, $soId: String!) {
    getCalculations(input: $input, soId: $soId) {
      code
      brandName
      actionLabel
      label
      priceWithoutDiscounts
      diffPrice
      prices {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      fixedCoverages {
        code
        label
        description
        tooltip
      }
      coverages {
        code
        label
        description
        tooltip
        editOnWeb
        price
      }
      visual {
        highlight
        discount
        tooltip
        description
      }
      logoUrl
    }
    overflowVoucherStatus {
      active
      voucherCode
      voucherValue
      voucherDescription
    }
    personalVoucherStatus(soId: $soId) {
      value
      code
      type
      description
      campaignName
      name
      generatedUniqueCodes
      startDate
      endDate
      status
    }
  }
`;
